import { HttpClient } from '#client/http/index'
import { NotificationListParams, NotificationId } from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const list = async (
  { httpClient }: { httpClient: HttpClient },
  params?: NotificationListParams,
): Promise<Notification[]> => {
  const { data: notifications }: ApiResponse<Notification[]> =
    await httpClient.get('/user/notifications', {
      params: {
        ...params,
        ...(params && params.isImportant ? { isImportant: 1 } : {}),
      },
    })
  return notifications
}

export const get = async (
  { httpClient }: { httpClient: HttpClient },
  id: NotificationId,
): Promise<Notification> => {
  const { data: notification }: ApiResponse<Notification> =
    await httpClient.get(`/user/notifications/${id}`)
  return notification
}
